import React from 'react'
// libs
import styled from 'styled-components'
import { Droppable, Draggable } from 'react-beautiful-dnd'
// view components
import Property from 'components/PageComponents/Settings/ObjectsAndProperties/Edit/Properties/components/Property'
// constants
import { COMMON_FIELDS, PROPERTIES_LISTS } from 'constants/objects'
// views
import { DropContainer } from 'components/PageComponents/Settings/ObjectsAndProperties/Edit/Properties/components/view'

// styled
const Wrapper = styled('div')`
  margin-right: 80px;
  min-width: 220px;
  width: 16%;
`

const Clone = styled(Property)`
  ~ div {
    transform: none !important;
  }
`

const PropertiesList: React.FC = () => {
  return (
    <Wrapper>
      Drag & and drop into either the Global Properties or Plan Types to create a new field
      <Droppable droppableId={PROPERTIES_LISTS.COMMON} isDropDisabled={true}>
        {(provided) => (
          <DropContainer ref={provided.innerRef}>
            {COMMON_FIELDS.map((item, index) => (
              <Draggable key={item.id} draggableId={item.id} index={index}>
                {(provided, snapshot) => (
                  <>
                    <Property
                      innerRef={provided.innerRef}
                      isDefaultProperty
                      property={item}
                      {...provided.draggableProps}
                      {...provided.dragHandleProps}
                    />
                    {snapshot.isDragging && <Clone property={item} isDefaultProperty />}
                  </>
                )}
              </Draggable>
            ))}
            {provided.placeholder}
          </DropContainer>
        )}
      </Droppable>
    </Wrapper>
  )
}

export default PropertiesList
